import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-notes-dialog',
  standalone: false,
  templateUrl: './notes-dialog.component.html',
  styleUrl: './notes-dialog.component.scss',
})
export class NotesDialogComponent implements OnChanges {

  @Input() title = 'Notes';
  @Input() notes: string | null | undefined = null;
  @Input() readOnly = false;
  @Output() save = new EventEmitter<string | null>();
  @Output() cancel = new EventEmitter<void>();

  draft: string = '';

  ngOnChanges(): void {
    this.draft = this.notes ?? '';
  }

  onSave(): void {
    this.save.emit(this.draft.trim() || null);
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
